export default __webpack_public_path__ + "static/2-4ba910bafcada6999be7a20ba4339f58.png";